import evaluationsConfig from '../Evaluations/moduleConfig';
import {i18nInit} from 'root/internationalization/config';

const config = {
    "APIs":{
        ...evaluationsConfig.APIs,
        ["getEvaluationType"]:"evaluations/getOnDemandProcedures",
        ["getProcedures"]: "procedures",
    },
    "map": {
		"PROCEDURE_EVALUATIONS_MODULE": {
            "name":i18nInit.t("lbl.PROCEDURES","Procedures"),
            "path":"procedureevaluations",
            "showInMenu": false,
            "entryPoint": "PROCEDURE_EVALUATIONS_LIST"
		},
        "LOG_PROCEDURE_EVALUATIONS": {
            "name":i18nInit.t("lbl.LOG_NEW_PROCEDURE","Log New Procedure"),
            "path":"procedureevaluations/log",
			"showInMenu": true
        },
		"PROCEDURE_EVALUATIONS_LIST": {
            "name":i18nInit.t("lbl.PROCEDURES","Procedures"),
            "path":"procedureevaluations",
			"showInMenu": false
		},
		"PROCEDURE_EVALUATION_FORM": {
            "name":i18nInit.t("lbl.PROCEDURES_FORM","Procedures Form"),
            "path":"procedureevaluations/form",
			"showInMenu": false
		}
    }
}

export default config;